import { useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Coaching", href: "#coaching-pricing" },
  { label: "CFO Accelerator", href: "/cfo-accelerator" },
  { label: "Resources", href: "#resources" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-linen bg-white/70 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src="/logo-bookcare.png"
            alt="BookCare LLC — Nurturing Prudent Decisions"
            className="h-12 w-12 rounded-sm object-cover"
            data-testid="nav-logo-img"
          />
          <span className="flex items-baseline gap-2">
            <span className="font-serif text-2xl font-semibold tracking-tight text-forest">BookCare</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-terra">LLC</span>
          </span>
        </a>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-pine/70 transition-colors duration-300 hover:text-forest"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#booking"
            data-testid="nav-book-consultation-btn"
            className="hidden border border-forest bg-forest px-6 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-transparent hover:text-forest md:inline-block"
          >
            Book Consultation
          </a>
          <button
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
            className="text-forest md:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-linen bg-bone px-6 py-6 md:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="font-mono text-sm uppercase tracking-[0.2em] text-pine/80"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#booking"
              data-testid="nav-mobile-book-btn"
              onClick={() => setOpen(false)}
              className="mt-2 inline-block border border-forest bg-forest px-6 py-3 text-center font-mono text-xs uppercase tracking-[0.2em] text-bone"
            >
              Book Consultation
            </a>
          </div>
        </div>
      )}
    </motion.header>
  );
}
